<template>
    <div class="main" style="padding: ">
        <!-- Loader -->

        <!-- Confirmation Module -->
        <v-dialog
            content-class="artDialog"
            persistent
            v-model="deleteConfirmationdialog"
            width="unset"
        >
            <v-card>
                <v-toolbar dense class="indigo darken-1 headline">
                    <v-toolbar-title class="white--text"
                        >Questo elemento verrà eliminato
                        definitivamente</v-toolbar-title
                    >
                </v-toolbar>
                <v-card-text class="mt-6">
                    <v-row class="mt-6 mb-3" justify="center" align="center">
                        <h3 style="text-align: left !important">
                            Confermi di voler eliminare questa macchina?
                        </h3>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        dark
                        @click="deleteConfirmationdialog = false"
                        >ANNULLA</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="green" dark @click="deleteMachina"
                        >CONFERMA</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="attrezzatureDialog" width="80vw">
            <v-card>
                <v-toolbar dense class="indigo darken-1 headline">
                    <v-toolbar-title class="white--text">
                        Attrezzature
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn small @click="attrezzatureDialog = false">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    depressed
                                    color="#c00000"
                                    >mdi-window-close</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Chiudi </span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <UpdateVehichleDetail
                        :defaultTab="4"
                        :orderId="macchina_sel.id_macchina"
                        :key="attrezzatureKey"
                    ></UpdateVehichleDetail>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Saving Confirmation Dialouge -->
        <!--Second Navbar with Files layout -->
        <v-dialog
            content-class="vehDialog"
            style="overflow-x: hidden !important"
            :scrollable="false"
            v-model="dialoginfo"
            width="400"
        >
            <v-card>
                <v-toolbar dense class="indigo darken-1 headline">
                    <v-toolbar-title class="white--text">
                        Dettaglio delle azioni per questa pagina
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="" x-small @click="dialoginfo = false">
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    depressed
                                    color="#c00000"
                                    >mdi-window-close</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Cancellare </span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-list disabled>
                        <v-subheader>Azioni</v-subheader>
                        <v-list-item-group color="primary">
                            <v-list-item
                                v-for="(item, i) in actionItems"
                                :key="i"
                            >
                                <v-list-item-icon>
                                    <v-icon :color="item.color">{{
                                        item.icon
                                    }}</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content
                                    style="text-align: left !important"
                                >
                                    <v-list-item-title>{{
                                        item.text
                                    }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Macchina Dialog To Save or Update The Macchina -->
        <v-dialog
            content-class="vehDialog"
            :scrollable="false"
            persistent
            fullscreen
            v-model="MacchinaFormDialog"
            width="1200"
        >
            <v-card>
                <v-toolbar dense class="indigo darken-1 headline">
                    <v-toolbar-title class="white--text"
                        >Macchina</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="allegatiVisible = true"
                                class="mr-5"
                                small
                                v-bind="attrs"
                                v-on="on"
                                :disabled="
                                    macchina_sel.id_macchina == undefined
                                "
                            >
                                <v-icon color="primary"> mdi-paperclip </v-icon>
                            </v-btn>
                        </template>
                        <span>Allegati</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="clickConnessioni"
                                class="mr-5"
                                small
                                v-bind="attrs"
                                v-on="on"
                                :disabled="
                                    macchina_sel.id_macchina == undefined
                                "
                            >
                                <v-icon color="primary"> mdi-leak </v-icon>
                            </v-btn>
                        </template>
                        <span>Connessioni</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                @click="consumidialog = true"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="primary">
                                    mdi-lightning-bolt
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Consumi</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                @click="dialog_calen = true"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="primary"
                                    >mdi-calendar-clock</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Imposta calendario</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                @click="submit"
                                small
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="success"> mdi-floppy </v-icon>
                            </v-btn>
                        </template>
                        <span>Salva Macchina</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                small
                                v-bind="attrs"
                                v-on="on"
                                @click="dialogAggiungiAllegato = true"
                            >
                                <v-icon color="#1a80b6">mdi-image</v-icon>
                            </v-btn>
                        </template>
                        <span>Cambia immagine</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="mr-5"
                                small
                                v-bind="attrs"
                                v-on="on"
                                @click="openAttrezzature"
                            >
                                <v-icon color="#1a80b6">mdi-wrench</v-icon>
                            </v-btn>
                        </template>
                        <span>Cambia immagine</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="closeModal" small>
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    depressed
                                    color="error"
                                    >mdi-keyboard-backspace</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Indietro</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text class="mt-5">
                    <v-form>
                        <v-row>
                            <v-col class="py-0" cols="2" md="1">
                                <TextField
                                    idForm="MACCHINA"
                                    idOggetto="CREA_CODICE_MACCHINA"
                                    label_input="Codice Macchina"
                                    palceholder_input="Codice Macchina"
                                    :vmodel="cod_macchina"
                                    v-on:changeText="
                                        (val) => (this.cod_macchina = val)
                                    "
                                />
                            </v-col>
                            <v-col class="py-0" cols="2" md="2">
                                <TextField
                                    idForm="MACCHINA"
                                    idOggetto="CREA_DES_MACCHINA"
                                    label_input="Descrizione Macchina"
                                    palceholder_input="Descrizione Macchina"
                                    :vmodel="des_macchina"
                                    v-on:changeText="
                                        (val) => (this.des_macchina = val)
                                    "
                                />
                            </v-col>
                            <v-col cols="2" md="2" class="py-0">
                                <TextField
                                    idForm="MACCHINA"
                                    idOggetto="CREA_MATRICOLA_MACCHINA"
                                    label_input="Matricola Macchina"
                                    palceholder_input="Matricola Macchina"
                                    :vmodel="matricola"
                                    v-on:changeText="
                                        (val) => (this.matricola = val)
                                    "
                                />
                            </v-col>
                            <v-col cols="2" md="2" class="py-0">
                                <TextField
                                    idForm="MACCHINA"
                                    idOggetto="CREA_MARCA_MACCHINA"
                                    label_input="Marca Macchina"
                                    palceholder_input="Marca Macchina"
                                    :vmodel="marca"
                                    v-on:changeText="
                                        (val) => (this.marca = val)
                                    "
                                />
                            </v-col>
                            <v-col cols="2" md="2" class="py-0">
                                <TextField
                                    idForm="MACCHINA"
                                    idOggetto="CREA_MODELLO_MACCHINA"
                                    label_input="Modello"
                                    palceholder_input="Modello"
                                    :vmodel="modello"
                                    v-on:changeText="
                                        (val) => (this.modello = val)
                                    "
                                />
                            </v-col>
                            <v-col class="py-0" cols="2" md="3">
                                <v-autocomplete
                                    v-model="id_stato"
                                    :items="des_stato_list"
                                    item-text="des"
                                    label="Stato"
                                    :placeholder="des_stato"
                                    required
                                    item-value="id_tabella"
                                >
                                    <template #label>
                                        <span class="">Stato</span>
                                        <a
                                            @click.stop
                                            style="pointer-events: all"
                                        >
                                            <Modules
                                                v-on:dialogModules="gettabelle"
                                                tipo="MACCHINA_STATO"
                                                nome="Stato"
                                                setaction="settabelle"
                                                getaction="gettabelle"
                                                controller="Magazzino"
                                                filter="validita = 1"
                                                :dati="[{ des: '' }]"
                                            />
                                        </a>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col class="py-0" md="2" cols="2">
                                <v-autocomplete
                                    v-model="id_tipo_get_macchina"
                                    :items="tipo_macchina_list"
                                    item-text="des"
                                    label="Tipo"
                                    :placeholder="
                                        id_tipo_get_macchina?.toString()
                                    "
                                    required
                                    item-value="id_tabella"
                                >
                                    <template #label>
                                        <span class="">Tipo</span>
                                        <a
                                            @click.stop
                                            style="pointer-events: all"
                                        >
                                            <Modules
                                                v-on:dialogModules="gettabelle"
                                                tipo="TIPO_GET_MACCHINA"
                                                nome="Tipo"
                                                setaction="settabelle"
                                                getaction="gettabelle"
                                                controller="Magazzino"
                                                filter="validita = 1"
                                                :dati="[{ des: '' }]"
                                            />
                                        </a>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col class="py-0" cols="2" md="2">
                                <v-autocomplete
                                    v-model="id_sub_tipo_macchina"
                                    :items="
                                        subtipoList.filter(
                                            (el) =>
                                                el.val_int ===
                                                id_tipo_get_macchina
                                        )
                                    "
                                    label="Sub Tipo Macchina"
                                    placeholder="Sub Tipo Macchina"
                                    item-text="des"
                                    item-value="id_tabella"
                                >
                                    <template #label>
                                        <span class=""
                                            >Sub Tipo Macc.<strong
                                                >*
                                            </strong></span
                                        >
                                        <span
                                            @click.stop
                                            style="
                                                min-width: 500px;
                                                pointer-events: all;
                                            "
                                        >
                                            <Modules
                                                v-on:dialogModules="gettabelle"
                                                tipo="SUB_TIPO_MACCHINA"
                                                nome="SubTipoMacchina"
                                                setaction="settabelle"
                                                getaction="gettabelle"
                                                controller="Magazzino"
                                                :filter="
                                                    '(val_int = ' +
                                                    id_tipo_get_macchina +
                                                    ') AND validita = 1'
                                                "
                                                :dati="[
                                                    { des: '' },
                                                    {
                                                        val_int:
                                                            id_tipo_get_macchina,
                                                    },
                                                ]"
                                            />
                                        </span>
                                    </template>
                                    <template v-slot:append>
                                        <v-icon
                                            v-if="
                                                id_sub_tipo_macchina != null &&
                                                id_sub_tipo_macchina != '' &&
                                                id_sub_tipo_macchina !=
                                                    undefined
                                            "
                                            color="red"
                                            @click="id_sub_tipo_macchina = null"
                                            >mdi-delete</v-icon
                                        >
                                    </template>
                                </v-autocomplete>
                            </v-col>
                             <v-col cols="4" md="2" class="py-0">
                                <TextField
                                    idForm="MACCHINA"
                                    idOggetto="CREA_TARGA_MACCHINA"
                                    label_input="Targa"
                                    palceholder_input="Targa"
                                    :vmodel="targa"
                                    v-on:changeText="
                                        (val) => (this.targa = val)
                                    "
                                />
                            </v-col>
                            <!-- <v-col class="py-0" cols="2" md="2">
                                <v-autocomplete
                                    v-model="id_stato"
                                    :items="des_stato_list"
                                    item-text="des"
                                    label="Stato"
                                    :placeholder="des_stato"
                                    required
                                    item-value="id_tabella"
                                >
                                    <template #label>
                                        <span class="">Stato</span>
                                        <a
                                            @click.stop
                                            style="pointer-events: all"
                                        >
                                            <Modules
                                                v-on:dialogModules="gettabelle"
                                                tipo="MACCHINA_STATO"
                                                nome="Stato"
                                                setaction="settabelle"
                                                getaction="gettabelle"
                                                controller="Magazzino"
                                                filter="validita = 1"
                                                :dati="[{ des: '' }]"
                                            />
                                        </a>
                                    </template>
                                </v-autocomplete>
                            </v-col> -->

                            <v-col cols="4" md="2" class="py-0">
                                <v-menu
                                    v-model="menu3"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="289"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="data_acquisto_formato"
                                            label="Data Acquisto"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="data_acquisto"
                                        @input="menu3 = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="4" md="2" class="py-0">
                                <v-menu
                                    v-model="menu_data_inizio_leasing"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="289"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="data_inizio_leasing_formato"
                                            label="Data Inizio Leasing"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="data_inizio_leasing"
                                        @input="menu_data_inizio_leasing = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="4" md="2" class="py-0">
                                <v-menu
                                    v-model="menu_data_fine_leasing"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="289"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="data_fine_leasing_formato"
                                            label="Data Fine Leasing"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="data_fine_leasing"
                                        @input="menu_data_fine_leasing = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="2" md="2" class="py-0">
                                <v-menu
                                    v-model="menu_inizio_garanzia"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="289"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="inizio_garanzia_formato"
                                            label="Inizio Garanzia"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="inizio_garanzia"
                                        @input="menu_inizio_garanzia = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="2" md="2" class="py-0">
                                <v-menu
                                    v-model="menu_fine_garanzia"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    min-width="289"
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            :value="fine_garanzia_formato"
                                            label="Fine Garanzia"
                                            prepend-icon="event"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="fine_garanzia"
                                        @input="menu_fine_garanzia = false"
                                    ></v-date-picker>
                                </v-menu>
                            </v-col>
                            
                            <v-col cols="4" md="2" class="py-0">
                                <TextField
                                    idForm="MACCHINA"
                                    idOggetto="CREA_DES_CONNESSIONE_MACCHINA"
                                    label_input="Des. Connessione"
                                    palceholder_input="Des. Connessione"
                                    :vmodel="des_connessione"
                                    v-on:changeText="
                                        (val) => (this.des_connessione = val)
                                    "
                                />
                            </v-col>
                           
                        </v-row>

                        <v-row>
                            <v-col class="py-0" cols="5" md="2">
                                <v-select
                                    v-model="macchina_4"
                                    :items="macchina_4_list"
                                    label="Impianto 4.0"
                                    placeholder="Impianto 4.0"
                                    required
                                    item-value="id"
                                    item-text="des"
                                ></v-select>
                            </v-col>
                            <v-col cols="2" class="py-0">
                                <v-switch
                                    v-model="multi_commessa"
                                    :false-value="0"
                                    :true-value="1"
                                    :label="'Multicommessa'"
                                ></v-switch>
                            </v-col>
                            <v-col cols="2" class="py-0">
                                <v-switch
                                    v-model="autonoma"
                                    :false-value="0"
                                    :true-value="1"
                                    :label="'Autonoma'"
                                ></v-switch>
                            </v-col>
                            <v-col cols="2" class="py-0">
                                <v-switch
                                    v-model="on_line"
                                    :false-value="0"
                                    :true-value="1"
                                    :label="'Online'"
                                ></v-switch>
                            </v-col>
                            <v-col cols="2" class="py-0 mb-1">
                                <v-switch
                                    v-model="tipo_connessione"
                                    :false-value="0"
                                    :true-value="1"
                                    :label="'Tipo Connessione'"
                                ></v-switch>
                            </v-col>
                            <v-col cols="2" class="py-0 mt-1">
                                <v-switch
                                    v-model="schedula"
                                    :false-value="0"
                                    :true-value="1"
                                    :label="'Schedula'"
                                ></v-switch>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="4" md="3" sm="3" class="py-0">
                                <v-autocomplete
                                    v-model="id_reparto"
                                    :items="des_reparto_list"
                                    item-text="descrizione"
                                    label="Reparto"
                                    :placeholder="des_reparto"
                                    required
                                    item-value="id_azienda_sede_reparto"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="4" md="2" sm="3" class="py-0">
                                <v-autocomplete
                                    v-model="id_funzione"
                                    :items="des_funzione_list"
                                    item-text="des"
                                    label="Funzione"
                                    :placeholder="des_funzione"
                                    required
                                    item-value="id_tabella"
                                >
                                    <template #label>
                                        <span class="">Funzione</span>
                                        <a
                                            @click.stop
                                            style="pointer-events: all"
                                        >
                                            <Modules
                                                v-on:dialogModules="gettabelle"
                                                tipo="MACCHINA_FUNZIONE"
                                                nome="Funzione"
                                                setaction="settabelle"
                                                getaction="gettabelle"
                                                controller="Magazzino"
                                                filter="validita = 1"
                                                :dati="[{ des: '' }]"
                                            />
                                        </a>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="4" md="3" sm="3" class="py-0">
                                <v-autocomplete
                                    v-model="id_centrocosto"
                                    :items="des_controcosto_list"
                                    item-text="des"
                                    label="Centro Costo"
                                    :placeholder="des_centrocosto"
                                    required
                                    item-value="id_tabella"
                                >
                                    <template #label>
                                        <span class="">Centro Costo</span>
                                        <a
                                            @click.stop
                                            style="pointer-events: all"
                                        >
                                            <Modules
                                                v-on:dialogModules="gettabelle"
                                                tipo="MACCHINA_CENTRO_COSTO"
                                                nome="Centro Costo"
                                                setaction="settabelle"
                                                getaction="gettabelle"
                                                controller="Magazzino"
                                                filter="validita = 1"
                                                :dati="[{ des: '' }]"
                                            />
                                        </a>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="2" md="2" sm="2" class="py-0">
                                <TextField
                                    idForm="MACCHINA"
                                    idOggetto="CREA_COSTO_ORARIO_MACCHINA"
                                    label_input="Costo Orario"
                                    palceholder_input="Costo Orario"
                                    :vmodel="costo_orario"
                                    :min_input="0"
                                    type_input="number"
                                    v-on:changeText="
                                        (val) => (this.costo_orario = val)
                                    "
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col sm="3" class="d-flex py-0" cols="8" md="8">
                                <v-textarea
                                    style="height: 150px"
                                    placeholder="Specifiche"
                                    v-model="specifiche"
                                    label="Specifiche"
                                ></v-textarea>
                            </v-col>
                            <v-col class="py-0" cols="12" md="4">
                                <v-row class="mt-6">
                                    <v-col
                                        v-if="macchina_img"
                                        md="8"
                                        cols="12"
                                        class="d-flex justify-center"
                                    >
                                        <div
                                            v-if="!isPdf(macchina_img)"
                                            v-viewer
                                            style="top: 20px"
                                            class="images clearfix"
                                        >
                                            <img
                                                id="immagine"
                                                style="
                                                    height: 80% !important;
                                                    width: 100%;
                                                    display: block !important;
                                                    margin-left: 2rem !important;
                                                "
                                                :src="macchina_img"
                                                :lazy-src="macchina_img"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                            />
                                        </div>
                                        <v-card
                                            @click="
                                                openPdfAppenaCaricato(
                                                    macchina_img
                                                )
                                            "
                                            style="
                                                height: 40px !important;
                                                width: 80px !important;
                                            "
                                            v-if="isPdf(macchina_img)"
                                        >
                                            <div style="text-align: center">
                                                <v-spacer></v-spacer>
                                                <v-icon color="error" x-large>
                                                    mdi-file-pdf-box
                                                </v-icon>
                                            </div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- To view Pdf Image -->
        <v-dialog content-class="artDialog" v-model="pdfdialog" width="unset">
            <iframe
                :src="this.selectedPdf"
                frameborder="0"
                style="height: 80vh !important; width: 90vw !important"
            >
            </iframe>
        </v-dialog>
        <!-- CONSUMI DIALOG -->
        <!-- To view Pdf Image -->
        <v-dialog
            content-class="artDialog"
            v-model="consumidialog"
            width="unset"
        >
            <v-card>
                <v-dialog
                    content-class="artDialog"
                    v-model="consumicreatedialog"
                    width="unset"
                >
                    <v-card>
                        <v-toolbar dense class="indigo darken-1" primary-title>
                            <v-toolbar-title class="white--text"
                                >Crea Consumi macchina</v-toolbar-title
                            >
                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="saveConsumi"
                                        v-on="on"
                                        v-bind="attrs"
                                        small
                                        class="mr-5"
                                    >
                                        <v-icon color="success"
                                            >mdi-floppy</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Crea Consumi</span>
                            </v-tooltip>

                            <v-spacer></v-spacer>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="ml-n4"
                                        @click="consumicreatedialog = false"
                                        small
                                    >
                                        <v-icon
                                            v-on="on"
                                            v-bind="attrs"
                                            depressed
                                            color="error"
                                            >mdi-window-close</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Cancellare</span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6">
                                    <v-autocomplete
                                        v-model="sel_consumi.id_articolo"
                                        :items="articolo_list"
                                        item-text="cod_articolo"
                                        label="Articolo"
                                        placeholder="Articolo"
                                        required
                                        item-value="id_articolo"
                                    >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="6">
                                    <InputSeparatore2
                                        label="KW/h"
                                        v-model="sel_consumi.kwh"
                                        :decimali_fissi="true"
                                        :key="input_extra_key"
                                        :numero_iniziale="sel_consumi.kwh"
                                        ref="input_extra"
                                        :numero_decimali="4"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-toolbar dense class="indigo darken-1" primary-title>
                    <v-toolbar-title class="white--text"
                        >Consumi macchina</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="createCosumi"
                                v-on="on"
                                v-bind="attrs"
                                small
                                class="mr-5"
                            >
                                <v-icon color="primary">mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Crea Consumi</span>
                    </v-tooltip>

                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-n4"
                                @click="consumidialog = false"
                                small
                            >
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    depressed
                                    color="error"
                                    >mdi-window-close</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Cancellare</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-data-table
                        :headers="cousumiHeader"
                        :items="MacchinaConsumiList"
                    >
                        <!-- Botton for updating Consumi -->
                        <template v-slot:[`item.edit`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="UpdateConsumi(item)"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="primary">
                                            mdi-pencil
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Modifica </span>
                            </v-tooltip>
                        </template>
                        <!-- Botton for deleting the Consumi -->
                        <template v-slot:[`item.delete`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        @click="deleteConsumi(item)"
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        <v-icon color="error">
                                            mdi-window-close
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Elimina</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog to Add new File to Articolo -->
        <v-dialog
            content-class="artDialog"
            persistent
            v-model="dialogAggiungiAllegato"
            width="500"
        >
            <v-card>
                <v-toolbar dense class="indigo darken-1" primary-title>
                    <v-toolbar-title class="white--text"
                        >Aggiungi allegati alla macchina</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn @click="setImmagine()" small>
                                <v-icon v-on="on" color="success" v-bind="attrs"
                                    >mdi-floppy</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Salva</span>
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-n4"
                                @click="dialogAggiungiAllegato = false"
                                small
                            >
                                <v-icon
                                    v-on="on"
                                    v-bind="attrs"
                                    depressed
                                    color="error"
                                    >mdi-window-close</v-icon
                                >
                            </v-btn>
                        </template>
                        <span>Cancellare</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card-text>
                    <v-text-field
                        v-model="allegato"
                        @paste="onPaste"
                        accept="image/x-png,image/gif,image/jpeg,image/jpg,image,image/PNG"
                        label="File"
                        prepend-icon="mdi-paperclip"
                        @click:prepend="openImagePicker"
                    ></v-text-field>
                    <input
                        type="file"
                        v-on:change="onFileChange"
                        ref="allegato"
                        name="allegato"
                        class="d-none"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Main Table For showing the List of Macchina -->
        <v-hover>
            <template v-slot="{ hover }">
                <v-card :elevation="hover ? 24 : 2" class="main-form" dense>
                    <v-toolbar dense color="indigo">
                        <v-toolbar-title class="white--text"
                            >Impianti
                            <v-icon color="white"
                                >mdi-robot-industrial</v-icon
                            ></v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <v-btn small @click="dialog_necessari = true"
                            ><v-icon color="primary">mdi-file</v-icon></v-btn
                        >
                        <v-spacer />
                        <Button
                            classe_bottone="mr-1"
                            colore_icona="primary"
                            idForm="MACCHINA"
                            idOggetto="CREA_MACCHINA"
                            mdi_icona="mdi-plus"
                            testo_tooltip="Nuova Macchina"
                            v-on:buttonClick="openModal"
                        >
                        </Button>

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="dialoginfo = true"
                                    v-on="on"
                                    v-bind="attrs"
                                    small
                                >
                                    <v-icon color="primary">
                                        mdi-information-outline
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Dettaglio delle Azioni</span>
                        </v-tooltip>
                        <v-text-field
                            style="background-color: white !important"
                            class="ml-2"
                            v-model="search"
                            label="Cerca"
                            single-line
                            hide-details
                        >
                            <v-icon slot="append" color="primary">
                                mdi-magnify
                            </v-icon>
                        </v-text-field>
                        <v-spacer></v-spacer>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    @click="gotoDashboard"
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                >
                                    <v-icon color="error"
                                        >mdi-keyboard-backspace</v-icon
                                    >
                                </v-btn>
                            </template>
                            <span>Vai alla Dashboard</span>
                        </v-tooltip>
                    </v-toolbar>
                    <v-card-subtitle
                        style="width: 30% !important; float: right !important"
                    >
                    </v-card-subtitle>
                    <v-card-text style="max-height: 600px; overflow-y: auto">
                        <v-data-table
                            :loading="loading"
                            dense
                            :headers="headers"
                            :search="search"
                            :items="MacchinaLista"
                            class="elevation-1 tablestyle"
                        >
                            <template v-slot:[`item.edit`]="{ item }">
                                <v-row>
                                    <v-col md="4" sm="4">
                                        <Button
                                            classe_bottone=""
                                            colore_icona="primary"
                                            idForm="MACCHINA"
                                            idOggetto="MODIFICA_MACCHINA"
                                            mdi_icona="mdi-pencil"
                                            stile_icona=""
                                            testo_tooltip="Aggiornare Macchina"
                                            v-on:buttonClick="
                                                setmacchina(item);
                                                getimageMacchina(item);
                                            "
                                        >
                                        </Button>
                                    </v-col>
                                    <v-col class="ml-6" md="4" sm="4">
                                        <Button
                                            classe_bottone=""
                                            colore_icona="#1a80b6"
                                            idForm="MACCHINA"
                                            idOggetto="VISUALIZZA_MACCHINA"
                                            mdi_icona="mdi-magnify"
                                            stile_icona=""
                                            testo_tooltip="Dettaglio Scheda"
                                            v-on:buttonClick="handleClick(item)"
                                        >
                                        </Button>
                                    </v-col>
                                </v-row>
                            </template>
                            <template
                                v-slot:[`item.prossima_scadenza`]="{ item }"
                            >
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            small
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="apriAllegati(item)"
                                            :color="
                                                documentiNecessari.filter(
                                                    (e) =>
                                                        e.id_macchina ==
                                                            item.id_macchina &&
                                                        e.num_allegati == 0 &&
                                                        (e.pk_riferimento ==
                                                            null ||
                                                            (e.pk_riferimento !=
                                                                null &&
                                                                item[
                                                                    e
                                                                        .pk_riferimento
                                                                ] ==
                                                                    e.id_riferimento))
                                                ).length != 0
                                                    ? '#555555'
                                                    : item.prossima_scadenza ==
                                                      -9999
                                                    ? undefined
                                                    : item.prossima_scadenza < 0
                                                    ? 'error'
                                                    : item.prossima_scadenza < 2
                                                    ? 'amber'
                                                    : 'success'
                                            "
                                            ><v-icon
                                                :color="
                                                    item.prossima_scadenza ==
                                                        -9999 &&
                                                    documentiNecessari.filter(
                                                        (e) =>
                                                            e.id_macchina ==
                                                                item.id_macchina &&
                                                            e.num_allegati ==
                                                                0 &&
                                                            (e.pk_riferimento ==
                                                                null ||
                                                                (e.pk_riferimento !=
                                                                    null &&
                                                                    item[
                                                                        e
                                                                            .pk_riferimento
                                                                    ] ==
                                                                        e.id_riferimento))
                                                    ).length == 0
                                                        ? 'primary'
                                                        : 'white'
                                                "
                                                >mdi-paperclip</v-icon
                                            ></v-btn
                                        >
                                    </template>
                                    <span>{{
                                        documentiNecessari.filter(
                                            (e) =>
                                                e.id_macchina ==
                                                    item.id_macchina &&
                                                e.num_allegati == 0 &&
                                                (e.pk_riferimento == null ||
                                                    (e.pk_riferimento != null &&
                                                        item[
                                                            e.pk_riferimento
                                                        ] == e.id_riferimento))
                                        ).length != 0
                                            ? "Allegati necessari mancanti"
                                            : item.prossima_scadenza == -9999
                                            ? "Nessun allegato"
                                            : item.prossima_scadenza > 0
                                            ? "Prossima scadenza in " +
                                              item.prossima_scadenza.toFixed(
                                                  2
                                              ) +
                                              " mesi : " +
                                              item.des_tipo_allegato +
                                              " - " +
                                              item.nome_file
                                            : "Scaduto " +
                                              (
                                                  item.prossima_scadenza * -1
                                              ).toFixed(2) +
                                              " mesi fa : " +
                                              item.des_tipo_allegato +
                                              " - " +
                                              item.nome_file
                                    }}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:[`item.delete`]="{ item }">
                                <Button
                                    classe_bottone="mr-5"
                                    colore_icona="error"
                                    idForm="MACCHINA"
                                    idOggetto="ELIMINA_MACCHINA"
                                    mdi_icona="mdi-window-close"
                                    stile_icona="float: left"
                                    testo_tooltip="Rimuovere Macchina"
                                    v-on:buttonClick="selectMachina(item)"
                                >
                                </Button>
                            </template>
                            <template v-slot:[`item.on_line`]="{ item }">
                                <v-icon v-if="item.on_line === 1"
                                    >mdi-checkbox-outline</v-icon
                                >
                                <v-icon v-else
                                    >mdi-checkbox-blank-outline</v-icon
                                >
                            </template>
                            <template v-slot:[`item.multi_commessa`]="{ item }">
                                <v-icon v-if="item.multi_commessa === 1"
                                    >mdi-checkbox-outline</v-icon
                                >
                                <v-icon v-else
                                    >mdi-checkbox-blank-outline</v-icon
                                >
                            </template>
                            <template v-slot:[`item.autonoma`]="{ item }">
                                <v-icon v-if="item.autonoma == 1"
                                    >mdi-checkbox-outline</v-icon
                                >
                                <v-icon v-else
                                    >mdi-checkbox-blank-outline</v-icon
                                >
                            </template>
                            <template v-slot:[`item.schedula`]="{ item }">
                                <v-icon v-if="item.schedula === 1"
                                    >mdi-checkbox-outline</v-icon
                                >
                                <v-icon v-else
                                    >mdi-checkbox-blank-outline</v-icon
                                >
                            </template>
                            <template
                                v-slot:[`item.tipo_connessione`]="{ item }"
                            >
                                <v-icon v-if="item.tipo_connessione === 1"
                                    >mdi-checkbox-outline</v-icon
                                >
                                <v-icon v-else
                                    >mdi-checkbox-blank-outline</v-icon
                                >
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </template>
        </v-hover>
        <!-- SnackBar to Show the Alerts Presents on this page -->
        <v-snackbar
            content-class="snackbar"
            :color="snackbar_background"
            right
            v-model="snackbar"
            :timeout="3000"
        >
            <v-icon :color="snackbar_icon_color" :size="64">{{
                snackbar_icon
            }}</v-icon>
            <h2
                :style="{ color: snackbar_text_color + '!important' }"
                class="ml-16"
            >
                {{ snackbar_text }}
            </h2>
            <v-btn
                @click="snackbar = false"
                fab
                dark
                text
                small
                style="
                    margin-top: -6rem;
                    float: right !important;
                    margin-right: -1rem !important;
                "
            >
                <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
            </v-btn>
        </v-snackbar>
        <!-- Dialog scelta calendario turni -->
        <v-dialog v-model="dialog_calen" persistent max-width="900px">
            <SchedaCalen @click_chiudi="chiudiDialogCalen" />
        </v-dialog>

        <v-dialog v-model="dialog_connessioni">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"
                        >Generazione Connessione</v-toolbar-title
                    >

                    <v-spacer></v-spacer>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="dialog_connessioni = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon color="error">mdi-close</v-icon></v-btn
                            >
                        </template>

                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card height="calc(100vh - 100px)" style="overflow: hidden">
                    <div class="pa-2" style="position: relative; height: 100%">
                        <WindowFrame
                            :component="'extapi'"
                            :input_args="{
                                id_macchina: macchina_sel.id_macchina,
                            }"
                            :key="key_conn"
                        >
                        </WindowFrame>
                    </div>
                </v-card>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_necessari">
            <v-card>
                <v-card height="calc(100vh - 100px)" style="overflow: hidden">
                    <div style="position: relative; height: 100%">
                        <WindowFrame
                            component="fwk"
                            :input_args="{
                                landing_page: '/documentinecessari',
                                riferimento: 'macchina',
                                campi: [
                                    {
                                        campo: 'id_tipo_get_macchina',
                                        testo: 'Tipo Macchina',
                                        tipo: 'TIPO_GET_MACCHINA',
                                        padre: '',
                                    },
                                    {
                                        campo: 'id_sub_tipo_macchina',
                                        testo: 'Sub Tipo Macchina',
                                        tipo: 'SUB_TIPO_MACCHINA',
                                        padre: 'id_tipo_get_macchina',
                                    },
                                ],
                            }"
                            :key="key_necessari"
                            @chiudi="dialog_necessari = false"
                        >
                        </WindowFrame>
                    </div>
                </v-card>
            </v-card>
        </v-dialog>

        <!-- DIALOG WARNING CANC -->
        <v-dialog v-model="dialog_warning_cancellazione">
            <v-card>
                <v-toolbar color="indigo" dense>
                    <v-toolbar-title class="white--text"
                        >Macchina Impegnata
                    </v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn @click="eliminaDefMacchina()" small color="success"
                        >Conferma Eliminazione
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                @click="dialog_warning_cancellazione = false"
                                small
                                v-bind="attrs"
                                v-on="on"
                                ><v-icon color="error">mdi-close</v-icon></v-btn
                            >
                        </template>

                        <span>Chiudi</span>
                    </v-tooltip>
                </v-toolbar>
                <v-card height="calc(100vh - 120px)" style="overflow: hidden">
                    <v-row class="pa-2">
                        <v-col v-if="array_articolo_ciclo_fasi_macchina.length">
                            <v-data-table
                                height="60vh"
                                :headers="headers_warning"
                                :items="array_articolo_ciclo_fasi_macchina"
                            >
                                <template v-slot:top>
                                    <v-toolbar color="indigo" dense>
                                        <v-toolbar-title class="white--text">
                                            Ciclo Fasi Macchina
                                        </v-toolbar-title>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-col
                            v-if="array_ciclostd_dettaglio_fasi_macchina.length"
                        >
                            <v-data-table
                                height="60vh"
                                :headers="headers_warning"
                                :items="array_ciclostd_dettaglio_fasi_macchina"
                            >
                                <template v-slot:top>
                                    <v-toolbar color="indigo" dense>
                                        <v-toolbar-title class="white--text">
                                            Ciclo Standard
                                        </v-toolbar-title>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-col
                            v-if="array_commessa_dettaglio_fasi_macchina.length"
                        >
                            <v-data-table
                                height="60vh"
                                :headers="headers_warning"
                                :items="array_commessa_dettaglio_fasi_macchina"
                            >
                                <template v-slot:top>
                                    <v-toolbar color="indigo" dense>
                                        <v-toolbar-title class="white--text">
                                            Commessa Dettaglio
                                        </v-toolbar-title>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-card>
        </v-dialog>

        <v-dialog class="ma-0 pa-0" v-model="allegatiVisible" width="90vw">
            <v-card
                class="ma-0 pa-0"
                height="calc(100vh - 100px)"
                style="overflow: hidden"
            >
                <div style="position: relative; height: 100%">
                    <WindowFrame
                        class="ma-0 pa-0"
                        referrerpolicy="origin"
                        @click_chiudi="allegatiVisible = false"
                        :component="'allegati'"
                        ref="windowframe_allegati"
                        :input_args="inputArgs"
                        :key="keyAllegati"
                    />
                </div>
            </v-card>
        </v-dialog>

        <SnackbarQV ref="SnackbarQV" />
    </div>
</template>
<script>
import moment from "moment";
import SchedaCalen from "./SchedaCalen.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import InputSeparatore2 from "@/components/TOOLS/InputSeparatore3.vue";
import Button from "../../../components/TOOLS/FormComponentPermissions/Button.vue";
import TextField from "../../../components/TOOLS/FormComponentPermissions/TextField.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";
import UpdateVehichleDetail from "@/views/PRODUCTION/Macchine/UpdateVehicleDetail.vue";
class Consumi {
    constructor(arg = undefined) {
        if (arg != undefined) {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] =
                    arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
            });
        } else {
            const campi = this.setCampi();
            campi.forEach((c) => {
                this[c.nome] = c.default_val;
            });
        }
    }

    // Metodo per resettare tutte le campi
    reset() {
        const campi = this.setCampi();

        campi.forEach((c) => {
            this[c.nome] = c.default_val;
        });
    }

    setCampi() {
        const campi = [
            { nome: "id_macchina", default_val: -1 },
            { nome: "id_consumi", default_val: -1 },
            { nome: "id_articolo", default_val: -1 },
            { nome: "cod_articolo", default_val: null },
            { nome: "kwh", default_val: 0.0 },
            { nome: "validita", default_val: 1 },
            { nome: "id_utente", default_val: null },
            { nome: "id_temp", default_val: -1 },

            // { nome: "data_ins", default_val: null },
            // { nome: "data_mod", default_val: null },
        ];

        return campi;
    }
}
export default {
    components: {
        Button,
        TextField,
        SchedaCalen,
        SnackbarQV,
        Modules: () => import("@/components/TOOLS/Modules"),
        InputSeparatore2,
        WindowFrame,
        UpdateVehichleDetail,
    },
    name: "VehicleDetail",
    props: ["Project"],
    data() {
        return {
            attrezzatureKey: true,
            attrezzatureDialog: false,
            documentiNecessari: [],
            key_necessari: true,
            dialog_necessari: false,
            keyAllegati: true,
            allegatiVisible: false,
            inputArgs: {
                cod_riferimento: "macchina",
                id_riferimento: -1,
                pk_riferimento: "id_macchina",
                id_utente: localStorage.id,
            },
            array_articolo_ciclo_fasi_macchina: [],
            array_ciclostd_dettaglio_fasi_macchina: [],
            array_commessa_dettaglio_fasi_macchina: [],
            dialog_warning_cancellazione: false,
            // Variable for Snackbar
            macchina_sel: {},
            macchina_4: 0,
            allegato: "",
            selectedPdf: false,
            overlay: false,
            snackbar: false,
            snackbar_background: "",
            snackbar_icon: "",
            snackbar_icon_color: "",
            snackbar_text: "",
            snackbar_text_color: "",
            // Dialogs And Progress Loader Presents on this Page
            dialogAggiungiAllegato: false,
            dialog_connessioni: false,
            pdfdialog: false,
            macchina_img: "",
            dialoginfo: false,
            deleteConfirmationdialog: false,
            MacchinaFormDialog: false,
            progressBar: false,
            loading: false,
            consumidialog: false,
            consumicreatedialog: false,
            key_conn: 0,
            //////////////////////////// Variables Needed to Create Updated and render data ///////////////////////////////
            MacchinaLista: [],
            MacchinaConsumiList: [],
            cousumiHeader: [
                {
                    text: "",
                    value: "edit",
                    sortable: false,
                },
                {
                    text: "Articolo",
                    value: "cod_articolo",
                    sortable: true,
                },
                {
                    text: "KW/h",
                    value: "kwh",
                    sortable: true,
                },

                {
                    text: "",
                    value: "delete",
                    sortable: false,
                },
            ],
            headers_warning: [
                {
                    text: "Cod. Macchina",
                    value: "cod_macchina",
                    sortable: true,
                },
                {
                    text: "Des. Macchina",
                    value: "des_macchina",
                    sortable: true,
                },
            ],
            macchina_4_list: [
                {
                    id: 0,
                    des: "Impianto non interconnesso",
                },
                {
                    id: 1,
                    des: "Impianto 4.0 standard",
                },
            ],
            sel_consumi: new Consumi(),
            selectedMacchina: {},
            id_centrocosto: "",
            id_funzione: "",
            id_macchina: "",
            id_reparto: "",
            id_stato: "",
            input_extra_key: 0,
            id_tipo_get_macchina: null,
            id_sub_tipo_macchina: null,
            id_utente: null,
            des_stato: "",
            des_reparto: "",
            des_centrocosto: "",
            des_funzione: "",
            des_connessione: "",
            des_macchina: "",
            des_funzione_list: [],
            des_stato_list: [],
            tipo_macchina_list: [],
            subtipoList: [],
            des_reparto_list: [],
            des_controcosto_list: [],
            deletedConsumi: [],
            item: "",
            autonoma: 0,
            cod_macchina: "",
            targa: "",
            data_acquisto: new Date(
                Date.now() - new Date().getTimezoneOffset() * 60000
            )
                .toISOString()
                .substr(0, 10),
            data_inizio_leasing: new Date(
                Date.now() - new Date().getTimezoneOffset() * 60000
            )
                .toISOString()
                .substr(0, 10),
            data_fine_leasing: new Date(
                Date.now() - new Date().getTimezoneOffset() * 60000
            )
                .toISOString()
                .substr(0, 10),
            inizio_garanzia: new Date(
                Date.now() - new Date().getTimezoneOffset() * 60000
            )
                .toISOString()
                .substr(0, 10),
            fine_garanzia: new Date(
                Date.now() - new Date().getTimezoneOffset() * 60000
            )
                .toISOString()
                .substr(0, 10),
            date_ins: new Date().toISOString().substr(0, 10),
            date_mod: new Date().toISOString().substr(0, 10),
            marca: "",
            matricola: "",
            modello: "",
            multi_commessa: 0,
            on_line: 0,
            schedula: 0,
            ore_disponibilita: 0,
            costo_orario: null,
            specifiche: null,
            tipo_connessione: 0,
            validita: 0,
            menu3: false,
            menu_fine_garanzia: false,
            menu_inizio_garanzia: false,
            menu_data_inizio_leasing: false,
            menu_data_fine_leasing: false,
            search: "",
            dialog_calen: false,
            headers: [],
            articolo_list: [],
            formsPermission: [
                {
                    id: 1,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_CODICE_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 2,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_DES_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 3,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_ID_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 4,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_MATRICOLA_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 5,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_MARCA_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 6,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_DES_CONNESSIONE_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 7,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_ORA_DISPONIBILITA_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 8,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_COSTO_ORARIO_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 9,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_DATA_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
                {
                    id: 10,
                    id_form: "MACCHINA",
                    nome_oggetto: "CREA_SPECIFICHE_MACCHINA",
                    flag_readonly: 0,
                    flag_hide: 0,
                    flag_obbligatorio: 0,
                },
            ],
            //////////////////////////// Items for Action Dialog ///////////////////////////////
            actionItems: [
                {
                    id: 1,
                    icon: "mdi-plus",
                    text: "Per aggiungere una nuova macchina",
                    color: "#1a80b6",
                },
                {
                    id: 2,
                    icon: "mdi-pencil",
                    text: "Per aggiornare la macchina esistente",
                    color: "#009999",
                },
                {
                    id: 3,
                    icon: "mdi-magnify",
                    text: "Per vedere la scheda della macchina",
                    color: "#1a80b6",
                },
                {
                    id: 4,
                    icon: "mdi-window-close",
                    text: "Per eliminare una macchina",
                    color: "#c00000",
                },
            ],
            // selectedHeaders: [],
            // Macchina Table Headers
            headersMap: {
                edit: {
                    align: "start",
                    value: "edit",
                    sortable: false,
                    width: "10px",
                },
                detail: {
                    align: "start",
                    value: "detail",
                    sortable: false,
                },
                autonoma: {
                    text: "Autonoma",
                    value: "autonoma",
                    sortable: false,
                },
                cod_macchina: {
                    text: "Cod. Macchina",
                    value: "cod_macchina",
                    sortable: false,
                    width: 1,
                },
                data_acquisto: {
                    text: "Data Acquisto",
                    value: "data_acquisto",
                    sortable: false,
                    width: 2,
                },
                inizio_garanzia: {
                    text: "Inizio Garanzia",
                    value: "inizio_garanzia",
                    sortable: false,
                    width: 2,
                },
                fine_garanzia: {
                    text: "Fine Garanzia",
                    value: "fine_garanzia",
                    sortable: false,
                    width: 2,
                },
                des_connessione: {
                    text: "Des Connessione",
                    value: "des_connessione",
                    sortable: false,
                },
                des_macchina: {
                    text: "Des Macchina",
                    value: "des_macchina",
                    sortable: false,
                },
                des_centrocosto: {
                    text: "Centrocosto",
                    value: "des_centrocosto",
                    sortable: false,
                },
                des_funzione: {
                    text: "Funzione",
                    value: "des_funzione",
                    sortable: false,
                },
                des_reparto: {
                    text: "Reparto",
                    value: "des_reparto",
                    sortable: false,
                },
                des_stato: {
                    text: "Stato",
                    value: "des_stato",
                    sortable: false,
                },
                marca: {
                    text: "Marca",
                    value: "marca",
                    sortable: false,
                },
                matricola: {
                    text: "Matricola",
                    value: "matricola",
                    sortable: false,
                },
                modello: {
                    text: "Modello",
                    value: "modello",
                    sortable: false,
                },
                multi_commessa: {
                    text: "Multi Commessa",
                    value: "multi_commessa",
                    sortable: false,
                },
                on_line: {
                    text: "On Line",
                    value: "on_line",
                    sortable: false,
                },
                schedula: {
                    text: "Schedulazione",
                    value: "schedula",
                    sortable: false,
                },
                ora_disponibilita: {
                    text: "Ora Disponibilita",
                    value: "ore_disponibilita",
                    sortable: false,
                },
                specifiche: {
                    text: "Specifiche",
                    value: "specifiche",
                    sortable: false,
                },
                tipo_connessione: {
                    text: "Tipo Connessione",
                    value: "tipo_connessione",
                    sortable: false,
                },
                delete: {
                    text: "",
                    value: "delete",
                    sortable: false,
                },
            },
            selectedItem: null,
        };
    },
    methods: {
        openAttrezzature() {
            this.attrezzatureKey = !this.attrezzatureKey;
            this.attrezzatureDialog = true;
        },
        clickConnessioni() {
            this.dialog_connessioni = true;
            this.key_conn = this.key_conn == 0 ? 1 : 0;
        },
        saveConsumi() {
            let data = this.sel_consumi;
            if (data.id_articolo === null || data.id_articolo === "") {
                this.$refs.SnackbarQV.print("orange", `Cod. Articolo è vuoto`);
                return;
            }
            if (data.kwh === null || data.kwh === "") {
                this.$refs.SnackbarQV.print("orange", `KW/h è vuoto`);
                return;
            }

            data.id_macchina = this.id_macchina;
            data.id_utente = parseInt(localStorage.id);
            let i = this.articolo_list.findIndex(
                (it) => it.id_articolo == data.id_articolo
            );
            data.cod_articolo = this.articolo_list[i].cod_articolo;
            if (data.id_temp === -1) {
                data.id_temp = moment().unix();
                this.MacchinaConsumiList.push(data);
            } else {
                let i = this.MacchinaConsumiList.findIndex(
                    (it) => this.sel_consumi.id_temp == it.id_temp
                );
                this.MacchinaConsumiList.splice(i, 1, this.sel_consumi);
            }

            this.consumicreatedialog = false;
        },
        UpdateConsumi(item) {
            this.sel_consumi = new Consumi(item);
            this.consumicreatedialog = true;
            this.$nextTick(() => {
                this.$refs.input_extra.numero_iniziale = this.sel_consumi.kwh;
            });

            if (this.articolo_list.length === 0) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Attenzione: non sono presenti articoli a sistema."
                );
            }
        },
        createCosumi() {
            this.sel_consumi = new Consumi();
            this.$nextTick(() => {
                this.$refs.input_extra.numero_iniziale = this.sel_consumi.kwh;
                this.input_extra_key = this.input_extra_key === 0 ? 1 : 0;
            });
            this.consumicreatedialog = true;

            if (this.articolo_list.length === 0) {
                this.$refs.SnackbarQV.print(
                    "orange",
                    "Attenzione: non sono presenti articoli a sistema."
                );
            }
        },
        deleteConsumi(item) {
            if (item.id_consumi > -1) {
                item.validita = 0;
                this.deletedConsumi.push(item);
            }
            let i = this.MacchinaConsumiList.indexOf(item);
            this.MacchinaConsumiList.splice(i, 1);
        },
        // Chiusura dialog calendario turni
        chiudiDialogCalen() {
            this.dialog_calen = false;
        },

        // get image
        getimageMacchina(item) {
            let finale = {
                controller: "Manutenzione",
                method: "POST",
                richiesta: {
                    action: "getmacchinapreviewimg",
                    token: localStorage.getItem("user_token"),
                    id_macchina: item.id_macchina,
                },
            };
            this.$store.dispatch("api", finale).then((res) => {
                this.macchina_img = res.data.result[0].macchina_img;
            });
        },
        getNecessariMacchine() {
            let finale = {
                controller: "Manutenzione",
                method: "POST",
                richiesta: {
                    action: "getdocumentinecessarimacchine",
                    token: localStorage.getItem("user_token"),
                },
            };
            this.$store.dispatch("api", finale).then((res) => {
                this.documentiNecessari = res.data.result;
            });
        },
        // to open Modal for PDF
        openPdfAppenaCaricato(item) {
            if (item.startsWith("data:application/pdf")) {
                this.selectedPdf = item;
                this.pdfdialog = true;
            }
        },
        // Function to handle pasted url of image
        onPaste(e) {
            if (e.clipboardData != false) {
                var items = e.clipboardData.items;
                if (items != undefined) {
                    for (var i = 0; i < items.length; i++) {
                        // Skip content if not image
                        if (items[i].type.indexOf("image") == -1) continue;
                        // Retrieve image on clipboard as blob
                        var blob = items[i].getAsFile();
                        console.log(blob);
                    }
                }
            }
            let that = this;
            this.retrieveImageFromClipboardAsBase64(
                e,
                function (imageDataBase64) {
                    that.macchina_img = imageDataBase64;
                }
            );
        },
        openImagePicker() {
            this.$refs.allegato.click();
        },
        hasExtension(file, exts) {
            return new RegExp(
                "(" + exts.join("|").replace(/\./g, "\\.") + ")$"
            ).test(file.name);
        },
        hideIcons() {
            this.hideicons = false;
            this.on = false;
            this.openAll = true;
            this.open = this.ids;
        },
        // Function to select an image and change it to base64
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            if (
                this.hasExtension(files[0], [
                    ".jpeg",
                    ".gif",
                    ".png",
                    ".jpg",
                    ".pdf",
                    ".PNG",
                ])
            ) {
                this.allegato = files[0];
                var reader = new FileReader();
                reader.readAsDataURL(this.allegato);
                let that = this;
                reader.onload = function () {
                    var image = new Image();
                    image.src = event.target.result;
                    image.onload = function () {
                        that.resizeImage(image, "immagine");
                    };
                    that.macchina_img = reader.result;
                    localStorage.setItem("MacchinaImage", that.macchina_img);
                };
                reader.onerror = function (error) {
                    console.log("Error: ", error);
                };
            } else {
                this.dialogAggiungiAllegato = false;
                this.snackbar = true;
                this.snackbar_background = "orange";
                this.snackbar_icon = "mdi-alert";
                this.snackbar_icon_color = "white";
                this.snackbar_text = "Formato non valido";
                this.snackbar_text_color = "white";
            }
            this.dialogAggiungiAllegato = false;
        },
        retrieveImageFromClipboardAsBase64(pasteEvent, callback, imageFormat) {
            if (pasteEvent.clipboardData == false) {
                if (typeof callback == "function") {
                    callback(undefined);
                }
            }
            var items = pasteEvent.clipboardData.items;
            if (items == undefined) {
                if (typeof callback == "function") {
                    callback(undefined);
                }
            }
            for (var i = 0; i < items.length; i++) {
                // Skip content if not image
                if (items[i].type.indexOf("image") == -1) continue;
                // Retrieve image on clipboard as blob
                var blob = items[i].getAsFile();
                // Create an abstract canvas and get context
                var mycanvas = document.createElement("canvas");
                var ctx = mycanvas.getContext("2d");
                // Create an image
                var img = new Image();
                // Once the image loads, render the img on the canvas
                img.onload = function () {
                    // Update dimensions of the canvas with the dimensions of the image
                    mycanvas.width = this.width;
                    mycanvas.height = this.height;
                    // Draw the image
                    ctx.drawImage(img, 0, 0);
                    // Execute callback with the base64 URI of the image
                    if (typeof callback == "function") {
                        callback(
                            mycanvas.toDataURL(imageFormat || "image/png")
                        );
                    }
                };
                // Crossbrowser support for URL
                var URLObj = window.URL || window.webkitURL;
                // Creates a DOMString containing a URL representing the object given in the parameter
                // namely the original Blob
                img.src = URLObj.createObjectURL(blob);
            }
            this.dialogAggiungiAllegato = false;
        },
        // In order to resize the image
        resizeImage(img, id) {
            if (img.width >= img.height && img.width > 100) {
                let width_nuova = 100;
                // Proporzione -> width_nuova : width = height_nuova : height
                let height_nuova = (width_nuova * img.height) / img.width;
                document.getElementById(id).style.width = width_nuova + "px";
                document.getElementById(id).style.height = height_nuova + "px";
            } else if (img.height > img.width && img.height > 100) {
                let height_nuova = 100;
                // Proporzione -> width_nuova : width = height_nuova : height
                let width_nuova = (height_nuova * img.width) / img.height;
                document.getElementById(id).style.width = width_nuova + "px";
                document.getElementById(id).style.height = height_nuova + "px";
            } else {
                document.getElementById(id).style.width = img.width + "px";
                document.getElementById(id).style.height = img.height + "px";
            }
        },
        // PDF MOdal
        isPdf(elem) {
            if (elem) {
                if (elem.startsWith("data:application/pdf")) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        // Method to get macchina to delete
        selectMachina(item) {
            this.selectedMacchina = item;
            this.deleteConfirmationdialog = true;
        },
        // Go back Radial Menu
        gotoDashboard() {
            if (this.Project === "QM") {
                this.$router.push("/home/quickmaintenance");
            } else {
                this.$router.push("/home/production");
            }
        },
        //  Populating the Form with exisiting value
        apriAllegati(item) {
            this.inputArgs.id_riferimento = item.id_macchina;
            this.allegatiVisible = true;
        },
        setmacchina(item) {
            this.macchina_sel = item;
            this.MacchinaFormDialog = true;
            this.inputArgs.id_riferimento = item.id_macchina;
            this.autonoma = item.autonoma;
            this.cod_macchina = item.cod_macchina;
            this.data_acquisto = item.data_acquisto;
            this.inizio_garanzia = item.inizio_garanzia;
            this.data_inizio_leasing = item.data_inizio_leasing;
            this.data_fine_leasing = item.data_fine_leasing;
            this.fine_garanzia = item.fine_garanzia;
            this.des_connessione = item.des_connessione;
            this.des_macchina = item.des_macchina;
            this.targa = item.targa;
            this.id_centrocosto = item.id_centrocosto;
            this.id_funzione = item.id_funzione;
            this.id_macchina = item.id_macchina;
            this.id_reparto = item.id_reparto;
            this.id_stato = item.id_stato;
            this.id_tipo_get_macchina = item.id_tipo_get_macchina;
            this.marca = item.marca;
            this.matricola = item.matricola;
            this.modello = item.modello;
            this.multi_commessa = item.multi_commessa;
            this.on_line = item.on_line;
            this.schedula = item.schedula;
            this.id_utente = item.id_utente;
            this.ore_disponibilita = item.ore_disponibilita;
            this.costo_orario = item.costo_orario;
            this.specifiche = item.specifiche;
            this.tipo_connessione = item.tipo_connessione;
            this.des_stato = item.des_stato;
            this.des_reparto = item.des_reparto;
            this.des_centrocosto = item.des_centrocosto;
            this.des_funzione = item.des_funzione;
            this.macchina_4 = item.flag_4_0;
            this.id_sub_tipo_macchina = item.id_sub_tipo_macchina;
            this.MacchinaConsumiList = item.consumi;
        },
        // Function to clear all the unsaved input values on close
        closeModal() {
            this.autonoma = "";
            this.cod_macchina = "";
            this.data_acquisto = "";
            this.inizio_garanzia = "";
            this.data_inizio_leasing = "";
            this.data_fine_leasing = "";
            this.fine_garanzia = "";
            this.des_connessione = "";
            this.des_macchina = "";
            this.id_centrocosto = "";
            this.id_funzione = "";
            this.id_macchina = "";
            this.id_reparto = "";
            this.id_stato = "";
            this.id_tipo_get_macchina = null;
            this.id_sub_tipo_macchina = null;
            this.marca = "";
            this.matricola = "";
            this.modello = "";
            this.multi_commessa = "";
            this.on_line = "";
            this.schedula = "";
            this.id_utente = "";
            this.ore_disponibilita = 0;
            this.costo_orario = null;
            this.specifiche = "";
            this.macchina_4 = 0;
            this.tipo_connessione = "";
            this.des_stato = "";
            this.des_reparto = "";
            this.des_centrocosto = "";
            this.des_funzione = "";
            this.targa = "";

            this.MacchinaFormDialog = false;
        },
        openModal() {
            this.macchina_img = "";
            this.MacchinaFormDialog = true;
            this.costo_orario = 0;
            this.MacchinaConsumiList = [];
        },
        // TO GO BACK TO Dashboard
        handleClick(value) {
            if (this.Project === "QM") {
                this.$router.push({
                    path: "/home/quickmaintenance/" + value.id_macchina,
                });
            } else {
                this.$router.push({
                    path: "/home/production/" + value.id_macchina,
                });
            }
        },
        // Function to create a new macchina
        submit() {
            this.overlay = true;
            if (!this.id_macchina) {
                if (this.cod_macchina === "") {
                    this.snackbar = true;
                    this.snackbar_background = "orange";
                    this.snackbar_icon = "mdi-alert";
                    this.snackbar_icon_color = "white";
                    this.snackbar_text =
                        "Il campo Codice Macchina è richiesto!";
                    this.snackbar_text_color = "white";
                    return;
                }
                if (this.des_macchina === "") {
                    this.snackbar = true;
                    this.snackbar_background = "orange";
                    this.snackbar_icon = "mdi-alert";
                    this.snackbar_icon_color = "white";
                    this.snackbar_text = "Il campo Des. Macchina è richiesto!";
                    this.snackbar_text_color = "white";
                    return;
                }
                if (this.targa === "") {
                    this.snackbar = true;
                    this.snackbar_background = "orange";
                    this.snackbar_icon = "mdi-alert";
                    this.snackbar_icon_color = "white";
                    this.snackbar_text = "Il campo Targa è richiesto!";
                    this.snackbar_text_color = "white";
                    return;
                }
                let data = {
                    autonoma: this.autonoma,
                    cod_macchina: this.cod_macchina,
                    data_acquisto: this.data_acquisto,
                    inizio_garanzia: this.inizio_garanzia,
                    data_inizio_leasing: this.data_inizio_leasing,
                    data_fine_leasing: this.data_fine_leasing,
                    fine_garanzia: this.fine_garanzia,
                    date_ins: this.date_ins,
                    date_mod: this.date_mod,
                    des_connessione: this.des_connessione,
                    des_macchina: this.des_macchina,
                    targa: this.targa,
                    id_centrocosto:
                        this.id_centrocosto != null ? this.id_centrocosto : "",
                    des_centrocosto:
                        this.id_centrocosto != null
                            ? this.id_centrocosto.des
                            : "",
                    id_funzione:
                        this.id_funzione != null ? this.id_funzione : "",
                    des_funzione:
                        this.id_funzione != null ? this.id_funzione.des : "",
                    id_macchina: -1,
                    id_reparto: this.id_reparto != null ? this.id_reparto : "",
                    des_reparto:
                        this.id_reparto != null ? this.id_reparto.des : "",
                    id_stato: this.id_stato != null ? this.id_stato : "",
                    des_stato: this.id_stato != null ? this.id_stato.des : "",
                    id_tipo_get_macchina: this.id_tipo_get_macchina,
                    id_sub_tipo_macchina: this.id_sub_tipo_macchina,
                    flag_4_0: this.macchina_4,
                    marca: this.marca,
                    matricola: this.matricola,
                    modello: this.modello,
                    multi_commessa: this.multi_commessa,
                    on_line: this.on_line,
                    schedula: this.schedula,
                    id_utente: localStorage.getItem("id"),
                    ore_disponibilita: this.ore_disponibilita,
                    costo_orario: this.costo_orario,
                    specifiche: this.specifiche,
                    tipo_connessione: this.tipo_connessione,
                    macchina_img: this.macchina_img,
                    consumi: this.MacchinaConsumiList,
                    validita: 1,
                };
                // data.Consumi = this.MacchinaConsumiList;
                let dataarray = [];
                dataarray.push(data);
                let finale = {
                    controller: "Manutenzione",
                    method: "PUT",
                    richiesta: {
                        action: "setmacchina",
                        token: localStorage.getItem("user_token"),
                        tabella: dataarray,
                    },
                };
                this.$store.dispatch("api", finale).then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        if (this.MacchinaConsumiList.length > 0) {
                            this.saveConsumi(res.data);
                        }

                        this.getMacchinaList();
                        this.snackbar = true;
                        this.snackbar_icon = "mdi-check";
                        this.snackbar_background = "success";
                        this.snackbar_text =
                            "Modifica effettuata con successo!";
                        this.snackbar_text_color = "white";
                    }
                });
            }
            if (this.id_macchina) {
                let data = {
                    autonoma: this.autonoma,
                    cod_macchina: this.cod_macchina,
                    data_acquisto: this.data_acquisto,
                    inizio_garanzia: this.inizio_garanzia,
                    data_inizio_leasing: this.data_inizio_leasing,
                    data_fine_leasing: this.data_fine_leasing,
                    fine_garanzia: this.fine_garanzia,
                    date_ins: this.date_ins,
                    date_mod: this.date_mod,
                    des_connessione: this.des_connessione,
                    des_macchina: this.des_macchina,
                    targa: this.targa,
                    flag_4_0: this.macchina_4,
                    id_centrocosto:
                        this.id_centrocosto != null ? this.id_centrocosto : "",
                    des_centrocosto:
                        this.id_centrocosto != null
                            ? this.id_centrocosto.des
                            : "",
                    id_funzione:
                        this.id_funzione != null ? this.id_funzione : "",
                    des_funzione:
                        this.id_funzione != null ? this.id_funzione.des : "",
                    id_macchina: this.id_macchina,
                    id_reparto: this.id_reparto != null ? this.id_reparto : "",
                    des_reparto:
                        this.id_reparto != null ? this.id_reparto.des : "",
                    id_stato: this.id_stato != null ? this.id_stato : "",
                    des_stato: this.id_stato != null ? this.id_stato.des : "",
                    id_tipo_get_macchina: this.id_tipo_get_macchina,
                    id_sub_tipo_macchina: this.id_sub_tipo_macchina,
                    marca: this.marca,
                    matricola: this.matricola,
                    modello: this.modello,
                    multi_commessa: this.multi_commessa,
                    on_line: this.on_line,
                    schedula: this.schedula,
                    id_utente: localStorage.getItem("id"),
                    ore_disponibilita: this.ore_disponibilita,
                    costo_orario: this.costo_orario,
                    specifiche: this.specifiche,
                    tipo_connessione: this.tipo_connessione,
                    macchina_img: this.macchina_img,
                    consumi: this.MacchinaConsumiList,
                    validita: 1,
                };
                if (this.deletedConsumi.length > 0) {
                    this.deletedConsumi.map((it) => {
                        data.consumi.push(it);
                    });
                }
                let dataarray = [];
                // data.consumi = this.MacchinaConsumiList;
                dataarray.push(data);
                let finale = {
                    controller: "Manutenzione",
                    method: "PUT",
                    richiesta: {
                        action: "setmacchina",
                        token: localStorage.getItem("user_token"),
                        tabella: dataarray,
                    },
                };
                this.$store.dispatch("api", finale).then((res) => {
                    this.overlay = false;
                    if (res.status == 200) {
                        this.getMacchinaList();
                        this.snackbar = true;
                        this.snackbar_icon = "mdi-check";
                        this.snackbar_background = "success";
                        this.snackbar_text =
                            "Modifica effettuata con successo!";
                        this.snackbar_text_color = "white";
                    }
                });
                const i = this.MacchinaLista.findIndex(
                    (it) => it.id_macchina === data.id_macchina
                );
                this.MacchinaLista.splice(i, 1, data);
            }
            this.autonoma = "";
            this.cod_macchina = "";
            this.data_acquisto = "";
            this.inizio_garanzia = "";
            this.data_inizio_leasing = "";
            this.data_fine_leasing = "";
            this.fine_garanzia = "";
            this.date_ins = "";
            this.date_mod = "";
            this.des_connessione = "";
            this.des_macchina = "";
            this.targa = "";
            this.id_centrocosto = "";
            this.id_funzione = "";
            this.id_macchina = "";
            this.id_reparto = "";
            this.macchina_4 = 0;
            this.id_stato = "";
            this.id_tipo_get_macchina = null;
            this.id_sub_tipo_macchina = null;
            this.marca = "";
            this.matricola = "";
            this.modello = "";
            this.multi_commessa = "";
            this.on_line = "";
            this.MacchinaFormDialog = false;
            this.ore_disponibilita = 0;
            this.costo_orario = null;
            this.specifiche = "";
            this.tipo_connessione = "";
        },
        // Function to delete Macchina
        deleteMachina() {
            let data = this.selectedMacchina;
            this.overlay = true;
            data.validita = 0;
            let dataarray = [data];
            let del = {
                controller: "Manutenzione",
                method: "PUT",
                richiesta: {
                    action: "updatemacchina",
                    token: localStorage.getItem("user_token"),
                    tabella: dataarray,
                },
            };
            this.$store.dispatch("api", del).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    if (res.data.response == false) {
                        this.array_articolo_ciclo_fasi_macchina =
                            res.data.result.articolo_ciclo_fasi_macchina;
                        this.array_ciclostd_dettaglio_fasi_macchina =
                            res.data.result.ciclostd_dettaglio_fasi_macchina;
                        this.array_commessa_dettaglio_fasi_macchina =
                            res.data.result.commessa_dettaglio_fasi_macchina;
                        this.dialog_warning_cancellazione = true;
                    } else {
                        this.getMacchinaList();
                        this.snackbar = true;
                        this.snackbar_icon = "mdi-check";
                        this.snackbar_background = "success";
                        this.snackbar_text =
                            "Modifica effettuata con successo!";
                        this.snackbar_text_color = "white";
                        this.deleteConfirmationdialog = false;
                    }
                }
            });
        },
        eliminaDefMacchina() {
            let data = this.selectedMacchina;
            this.overlay = true;
            data.validita = 0;
            let dataarray = [data];
            let del = {
                controller: "Manutenzione",
                method: "PUT",
                richiesta: {
                    action: "updatemacchina",
                    token: localStorage.getItem("user_token"),
                    tabella: dataarray,
                    forza_elimina_macchina: 1,
                },
            };
            this.$store.dispatch("api", del).then((res) => {
                this.overlay = false;
                if (res.status == 200) {
                    this.getMacchinaList();
                    this.snackbar = true;
                    this.snackbar_icon = "mdi-check";
                    this.snackbar_background = "success";
                    this.snackbar_text = "Modifica effettuata con successo!";
                    this.snackbar_text_color = "white";
                    this.deleteConfirmationdialog = false;
                }
            });
        },
        async getReparti() {
            let request = {
                controller: "schedulatore",
                method: "POST",
                richiesta: {
                    token: localStorage.getItem("user_token"),
                    action: "getaziendasedereparti",
                    id_azienda: 1,
                    id_azienda_sede: null,
                    id_azienda_sede_reparto: null,
                },
            };

            await this.$store.dispatch("api", request).then((res) => {
                this.des_reparto_list = res.data.result;
            });
        },
        // Get Macchina lista
        gettabelle() {
            let req_data = {
                controller: "Magazzino",
                method: "POST",
                richiesta: {
                    action: "gettabelle",
                    token: localStorage.getItem("user_token"),
                    filter: "validita = 1",
                    tipo: "'MACCHINA_STATO','MACCHINA_FUNZIONE','MACCHINA_CENTRO_COSTO','TIPO_GET_MACCHINA','SUB_TIPO_MACCHINA'",
                },
            };
            this.$store.dispatch("api", req_data).then((res) => {
                if (res.status != 204 && res.data != "") {
                    this.des_controcosto_list = res.data.MACCHINA_CENTRO_COSTO
                        ? res.data.MACCHINA_CENTRO_COSTO
                        : [];
                    this.des_funzione_list = res.data.MACCHINA_FUNZIONE
                        ? res.data.MACCHINA_FUNZIONE
                        : [];
                    this.des_stato_list = res.data.MACCHINA_STATO
                        ? res.data.MACCHINA_STATO
                        : [];
                    this.tipo_macchina_list = res.data.TIPO_GET_MACCHINA
                        ? res.data.TIPO_GET_MACCHINA
                        : [];
                    this.subtipoList = res.data.SUB_TIPO_MACCHINA
                        ? res.data.SUB_TIPO_MACCHINA
                        : [];
                }
            });
        },
        getMacchinaList() {
            let manu_detail = {
                controller: "Manutenzione",
                method: "POST",
                richiesta: {
                    action: "getlistamacchine",
                    token: localStorage.getItem("user_token"),
                },
            };
            this.loading = true;
            this.progressBar = true;
            this.$store.dispatch("api", manu_detail).then((res) => {
                this.loading = false;
                this.progressBar = false;
                this.MacchinaLista = res.data.macchine;
                if (res.data.header) {
                    // Aggiungo i pulsanti edit e detail all'array
                    this.headers = Object.values(this.headersMap).slice(0, 3);
                    // aggiungo gli header arrivati dal backend in ordine
                    this.headers = this.headers.concat(
                        res.data.header
                            .filter((e) => e.visible == 1)
                            .sort((a, b) => a.ordine - b.ordine)
                    );
                    this.headers.push({
                        text: "",
                        value: "delete",
                        sortable: false,
                    });
                }
            });
        },
    },
    created() {
        this.headers = Object.values(this.headersMap);
        // this.selectedHeaders = this.headers;
    },
    computed: {
        data_acquisto_formato() {
            return this.data_acquisto
                ? moment(this.data_acquisto, [
                      "DD/MM/YYYY hh:mm:ss",
                      "YYYY-MM-DD",
                  ]).format("DD/MM/YYYY")
                : "";
        },
        inizio_garanzia_formato() {
            return this.inizio_garanzia
                ? moment(this.inizio_garanzia, [
                      "DD/MM/YYYY hh:mm:ss",
                      "YYYY-MM-DD",
                  ]).format("DD/MM/YYYY")
                : "";
        },
        data_inizio_leasing_formato() {
            return this.data_inizio_leasing
                ? moment(this.data_inizio_leasing, [
                      "DD/MM/YYYY hh:mm:ss",
                      "YYYY-MM-DD",
                  ]).format("DD/MM/YYYY")
                : "";
        },
        data_fine_leasing_formato() {
            return this.data_fine_leasing
                ? moment(this.data_fine_leasing, [
                      "DD/MM/YYYY hh:mm:ss",
                      "YYYY-MM-DD",
                  ]).format("DD/MM/YYYY")
                : "";
        },
        fine_garanzia_formato() {
            return this.fine_garanzia
                ? moment(this.fine_garanzia, [
                      "DD/MM/YYYY hh:mm:ss",
                      "YYYY-MM-DD",
                  ]).format("DD/MM/YYYY")
                : "";
        },
        //Done to get the ordered headers
        // showHeaders() {
        //   return this.headers.filter((s) => this.selectedHeaders.includes(s));
        // },
    },
    mounted() {
        this.getNecessariMacchine();
        this.getReparti();
        localStorage.setItem(
            "matrice_autorizzazioni",
            JSON.stringify(this.formsPermission)
        );
        this.getMacchinaList();
        // To Populate all list of data require to create a new macchina
        let req_data = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
                action: "gettabelle",
                token: localStorage.getItem("user_token"),
                filter: "validita = 1",
                tipo: "'MACCHINA_STATO','MACCHINA_FUNZIONE','MACCHINA_CENTRO_COSTO','TIPO_GET_MACCHINA','SUB_TIPO_MACCHINA'",
            },
        };
        this.$store.dispatch("api", req_data).then((res) => {
            if (res.status != 204 && res.data != "") {
                this.des_controcosto_list = res.data.MACCHINA_CENTRO_COSTO
                    ? res.data.MACCHINA_CENTRO_COSTO
                    : [];
                this.des_funzione_list = res.data.MACCHINA_FUNZIONE
                    ? res.data.MACCHINA_FUNZIONE
                    : [];
                this.des_stato_list = res.data.MACCHINA_STATO
                    ? res.data.MACCHINA_STATO
                    : [];
                this.tipo_macchina_list = res.data.TIPO_GET_MACCHINA
                    ? res.data.TIPO_GET_MACCHINA
                    : [];
                this.subtipoList = res.data.SUB_TIPO_MACCHINA
                    ? res.data.SUB_TIPO_MACCHINA
                    : [];
            }
        });
        // To populate main table
        // Chiamata commentata perché dava snackbar per risultati vuoti e nessuno sa a che serve
        /* let search_Articolo = {
            controller: "Magazzino",
            method: "POST",
            richiesta: {
                action: "getarticoli",
                token: localStorage.getItem("user_token"),
                cod_articolo: "*",
            },
        };

        // Eseguo la chiamata al BE
        this.$store.dispatch("api", search_Articolo).then((res) => {
            this.articolo_list = res.data.lista;
        });*/
    },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.icon2 {
    margin-top: -7px !important;
}
.v-card1 {
    height: 48px !important;
}
</style>
